import { kongApi } from 'packages/common/helpers/api';

const api = kongApi({
  baseURL: `${process.env.VUE_APP_BASE_URL_PERSONNEL_DEPARTMENT}/`,
});

export default {
  generateBankFile(bankFile) {
    return api.post('arquivos/bancos', bankFile, { responseType: 'blob' });
  },
  getMovementFiles(period) {
    return api.get(`exportacoes/movimentos/${period}`);
  },
  editMovementFiles(period, movementFiles) {
    return api.put(`exportacoes/movimentos/${period}`, movementFiles, { responseType: 'blob' });
  },
};
